import axios from '../config/axios.js';

class CommonService {
  getCountries = () => {
    return axios
      .get('/get-countries')
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

}

export default new CommonService()